import Vue from "vue";
import Router from "vue-router";
import home from "../views/home.vue";
import login from "../views/login.vue";
import store from "./../vuex/store";

// lababiz
import eventForm from "../views/event/eventForm.vue";
import eventBooth from "../views/event/eventBooth.vue";
import eventBoothReport from "../views/event/eventBoothSummaryReport.vue";
import participateForm from "../views/event/participateForm.vue";
import participateFormAtEvent from "../views/event/participateFormAtEvent.vue";
import participateFormForOrganizer from "../views/event/participateFormForOrganizer.vue";
import participate from "../views/event/participate.vue";
import register from "../views/event/selfRegister.vue";
import registerpay from "../views/event/selfRegisterPay.vue";
import registerpaybyscan from "../views/event/selfRegisterPayByScan.vue";
import participateCompetitionForm from "../views/event/participateCompetitionForm.vue";
import participateCompetitionFormbySelf from "../views/event/participateCompetitionFormbySelf.vue";
import competitionForm from "../views/event/competitionForm.vue";  
import businessMatchingForm from "../views/event/businessMatchingForm.vue";  
import businessMatchingInterested from "../views/event/businessMatchingInterested.vue";  
import businessMatchingQR from "../views/event/businessMatchingQR.vue";  
import associationForm from "../views/association/associationForm.vue";  
import associationFormbySelf from "../views/association/associationFormbySelf.vue";  
import associationregisterqr from "../views/association/registerQR.vue";  
import informationform from "../views/information/informationform.vue";  
import informationbyQR from "../views/information/informationbyQR.vue";  

import changepassword from "../views/event/changepassword.vue";  

import checkParticipate from "../views/event/checkParticipate.vue";
import checkParticipateByPhoneno from "../views/event/checkParticipateByPhoneno.vue";
import eventQRList from "../views/event/eventQRList.vue";


// report 
import reportEventlist from "../views/report/eventlist.vue";
import reportCompetition from "../views/report/competition.vue";
import reportBusinessMatching from "../views/report/businessmatching.vue";
import reportMember from "../views/report/member.vue";

//page

import laba_about from "../views/pages/laba/about.vue";
import laba_remark from "../views/pages/laba/remark.vue";
import laba_member from "../views/pages/laba/member.vue";

import mou_adra from "../views/pages/mou/adra.vue"; 
import mou_fvc from "../views/pages/mou/fvc.vue"; 
import mousweetpotato from "../views/pages/mou/sweetpotato.vue";     
import mouchili from "../views/pages/mou/chili.vue";   

import businessmatchinginterested from "../views/pages/business/businessMatchingInterested.vue";          
import businessmatching from "../views/pages/business/businessMatching.vue";          


import inexpo from "../views/pages/news/inexpo.vue";   
import news02 from "../views/pages/news/news02.vue";  

import agentda from "../views/pages/event2024/agenda.vue";   


import lababizsponsor from "../views/pages/sponsor/lababizsponsor.vue";   



// import aboutexpo from "../views/pages/expo/aboutexpo.vue";




Vue.use(Router);

const router = new Router({  
  // mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },

    {
      path: '/event/checkParticipate/:regno',
      name: 'checkParticipate',
      component: checkParticipate,
      props: true, // Enables passing the 'id' as a prop to the component
    
    },

    {
      path: '/event/checkParticipateByPhoneno',
      name: 'checkParticipateByPhoneno',
      component: checkParticipateByPhoneno,

    
    },

    {
      path: "/event/eventForm",
      name: "event/eventForm",
      component: eventForm,
      meta: {
        requiresAuth: true
      }
      
    },

    {
      path: "/event/booth",
      name: "event/booth",
      component: eventBooth,  
      meta: {
        requiresAuth: true
      }
      
    },

    {
      path: "/event/boothreport",
      name: "event/boothreport",
      component: eventBoothReport,
      meta: {
        requiresAuth: true
      }
      
    },

    {
      path: "/event/participateForm",
      name: "participateForm",
      component: participateForm,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/participateFormAtEvent",
      name: "participateFormAtEvent",
      component: participateFormAtEvent,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/participateFormForOrganizer",
      name: "participateFormForOrganizer",
      component: participateFormForOrganizer,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/event/participateForm/:regno',
      name: 'ParticipateFormWithId',
      component: participateForm,
      props: true, // Enables passing the 'id' as a prop to the component
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/participate",
      name: "participate",
      component: participate,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/eventQRList",
      name: "eventQRList",
      component: eventQRList,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/register/:eventid",
      name: "register",
      component: register,
      props: true, // Enables passing the 'id' as a prop to the component
    },

    {
      path: "/event/registerpay/:eventid",
      name: "registerpay",
      component: registerpay,
      props: true, // Enables passing the 'id' as a prop to the component
    },

    {
      path: "/event/registerpaybyscan",
      name: "registerpaybyscan",
      component: registerpaybyscan,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/participateCompetitionForm",
      name: "participateCompetitionForm",
      component: participateCompetitionForm,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/participateCompetitionFormbySelf",
      name: "participateCompetitionFormbySelf",
      component: participateCompetitionFormbySelf,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/competitionForm",
      name: "competitionForm",
      component: competitionForm,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/businessMatchingForm",
      name: "businessMatchingForm",
      component: businessMatchingForm,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/businessMatchingInterested",
      name: "businessMatchingInterested",
      component: businessMatchingInterested,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/event/businessMatchingQR",
      name: "businessMatchingQR",
      component: businessMatchingQR,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/association/associationForm",
      name: "associationForm",
      component: associationForm,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/association/registerqr",
      name: "associationregisterqr",
      component: associationregisterqr,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/association/associationFormbySelf",
      name: "associationFormbySelf",
      component: associationFormbySelf,
     
    },

    
    {
      path: "/information/informationform",
      name: "informationform",
      component: informationform,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/information/informationbyQR",
      name: "informationbyQR",
      component: informationbyQR,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/profile/changepassword",
      name: "changepassword",
      component: changepassword,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/report/eventlist",
      name: "reportEventlist",
      component: reportEventlist,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/report/competition",
      name: "reportCompetition",
      component: reportCompetition,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/report/businessmatching",
      name: "reportBusinessMatching",
      component: reportBusinessMatching,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/report/member",
      name: "reportMember",
      component: reportMember,
      meta: {
        requiresAuth: true
      }
    },


    // {
    //   path: "/register",
    //   name: "register",
    //   component: register
    // },
    {
      path: "/",
      name: "home",
      component: home,
    },

    {
      path: "/home",
      name: "home",
      component: home,
    },

    {
      path: "/mou/adra",
      name: "mou_adra",
      component: mou_adra,
    },

    {
      path: "/mou/fvc",
      name: "mou_fvc",
      component: mou_fvc,
    },

    {
      path: "/mou/sweetpotato",
      name: "mousweetpotato",
      component: mousweetpotato,
    },

    {
      path: "/mou/chili",
      name: "mouchili",
      component: mouchili,
    },

    {
      path: "/laba/about",
      name: "laba_about",
      component: laba_about,
    },

    {
      path: "/laba/remark",
      name: "laba_remark",
      component: laba_remark,
    },
    {
    
    path: "/laba/member",
    name: "laba_member",
    component: laba_member,
  },

    
    {
      path: "/business/businessmatching",
      name: "businessmatching",
      component: businessmatching,
    },

    {
      path: "/business/businessmatchinginterested",
      name: "businessmatchinginterested",
      component: businessmatchinginterested,
    },


    
    {
      path: "/news/inexpo",
      name: "inexpo",
      component: inexpo,
    },

    {
      path: "/news/news02",
      name: "news02",
      component: news02,
    },

    {
      path: "/event2024/agentda",
      name: "agentda",
      component: agentda,
    },

    {
      path: "/sponsor/lababizsponsor",
      name: "lababizsponsor",
      component: lababizsponsor,
    },


    // {
    //   path: "/expo/aboutexpo",
    //   name: "aboutexpo",
    //   component: aboutexpo,
    // },


    
    

    {
      path: "*",
      name: "404",
      component: () =>
        import( /* webpackChunkName: "notfound" */ "@/views/notFound.vue")
    }
  ]
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const token = store.get("token");
  // if (requiresAuth && !token) {
  //   next("/login");
  // } else if (requiresAuth && token) {
  //   const exp = store.get("decodedToken@exp");
  //   const now = new Date().getTime() / 1000; //time in second
  //   if (exp > now) {
  //     next();
  //   } else {
  //     Vue.swal({
  //       type: "error",
  //       text: "ໝົດເວລາ ນຳໃຊ້ລະບົບ, ກະລຸຸນາ ເຂົ້າລະບົບອີກຄັ້ງ"  
  //     });
  //     next("/login");
  //   }  
  // } else {
  //   next();  
  // }
  if (requiresAuth && !token) {
    next("/home");
  } else if (requiresAuth && token) {
    const exp = store.get("decodedToken@exp");
    const now = new Date().getTime() / 1000; //time in second
    if (exp > now) {
      next();
    } else {
      Vue.swal({
        type: "error",
        text: "ໝົດເວລາ ນຳໃຊ້ລະບົບ, ກະລຸຸນາ ເຂົ້າລະບົບອີກຄັ້ງ"
      });
      next("/login");
    }
  } else {
    next();
  }
});

export default router;